export const main = {
  light: {
    body_bg: "white",
    content_bg: "#fff"
  },
  dark: {
    body_bg: "#161C24",
  },
};

export const grey = {
  light: {
    900: "#2B3445", // Main Text
    800: "#373F50", // Paragraph
    700: "#4B566B",
    600: "#7D879C", // Low Priority form Title/Text
    500: "#AEB4BE",
    400: "#DAE1E7", // Border
    300: "#F5F5F5",
    200: "#F3F5F9", // Line Stroke
    100: "#F6F9FC",
  },
  dark: {
    100: "#2B3445", // Main Text
    200: "#4d4d50", // Paragraph
    300: "#6d6d70",
    400: "#9a9b9f", // Low Priority form Title/Text
    500: "#b8babd",
    600: "#e4e6e8", // Border
    700: "#F5F5F5",
    800: "#F3F5F9", // Line Stroke
    900: "#F6F9FC",
  },
};

export const primary = {
  100: "#a9c5fc",
  200: "#7ea8fb",
  300: "#528bfa",
  400: "#007cb0", // default color
  500: "#2463e0",
  600: "#2058c7",
  700: "#17449b",
  800: "#0F3460",
  900: "#0B274E",
};

export const secondary = {
  100: "#e8e8ee",
  200: "#b9bacb",
  300: "#8a8ca8",
  400: "#5b5d85",
  500: "#141850",
  600: "#0F3460",
  700: "#101340",
  800: "#0e1138",
  900: "#0c0e30",
  // main: "#0F3460",
  // dark: "#0c0e30",
};

export const error = {
  100: "#FFEAEA",
  200: "#FFCBCB",
  300: "#FFA9A9",
  400: "#FF6D6D",
  500: "#FF5353",
  600: "#FF4C4C",
  700: "#FF4242",
  800: "#FF3939",
  900: "#FF2929",
  // main: "#E94560",
};

export const success = {
  100: "#E7F9ED",
  200: "#C2F1D1",
  300: "#99E8B3",
  400: "#52D77E",
  500: "#33D067",
  600: "#2ECB5F",
  700: "#27C454",
  800: "#20BE4A",
  900: "#0b7724",
  // main: "rgb(51, 208, 103)",
};

export const info = {
  500: "#CCE3FF",
  700: "#03A9F4",
};

export const warning = {
  100: "#fcc47f",
  200: "#ffb55c",
  300: "#ffa42f",
  400: "#ff9913",
  500: "#ff7300",
  600: "#ff5900",
  700: "#ff5900",
  800: "#ff2f00",
  900: "#c73202",
  main: "#ff7300",
  contrastText: "#FFFFFF",
};

export const custom = {
  layoutBackground: {
    grey: "#eee",
  },
  primaryBtnColor: "white",
  navigationSvgIconColor: "#3ab4e8",
  googleColor: "#f05c4f",
  facebookColor: "#3B5998",
  inputBackground: "#fcfcfb",
  stripe: { color: "#655BFF", hover: "#443dcc" },
};
